'use client';
import { createContext } from '@radix-ui/react-context';
import { ACTION_AREA_NAME } from './constants.mjs';

// src/components/action-area/contexts.ts
var [ActionAreaProvider, useActionAreaContext] = createContext(ACTION_AREA_NAME);

export { ActionAreaProvider, useActionAreaContext };
